
import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "ConstellationIcon",

  data() {
    return {
    };
  },

  props: {
    width: {
      type: String,
      required: false,
      default: "100%",
    },
    height: {
      type: String,
      required: false,
      default: "100%",
    },

    color: {
      type: String,
      required: false,
      default: "white",
    },

    fill: {
      type: Boolean,
      required: false,
      default: false,
    },
    
    fillColor: {
      type: String,
      required: false,
      default: null,
    },

    selected: {
      type: Boolean,
      required: false,
      default: false,
    },

    selectedStyle: {
      type: String,
      required: false,
      default: "",
    }
  },


  watch: {
    active: function (val) {
      console.log("active changed to: " + val);
    },
  },

  computed: {
    computedFillColor() {
      return this.fillColor ? this.fillColor : this.color;
    }
  }
  
});


import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "611f22ea": (_ctx.width),
  "634d1fb0": (_ctx.color),
  "eb8e7750": (_ctx.computedFillColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__